import React from 'react';
import './ForecastingMatters.css';

// Data for the six benefit cards
const mattersData = [
  {
    title: 'Robust raw material & procurement planning',
    description: 'To align your purchases with market direction across the value chain, ensuring cost stability and optimal contract timing.'
  },
  {
    title: 'Strategic pricing decisions',
    description: 'Adjust finished product pricing confidently based on regional outlooks. Whether it\'s crops, produce, or feed, pricing becomes proactive, not reactive.'
  },
  {
    title: 'Production & inventory optimization',
    description: 'Plan what to produce, where to supply, and when to stock, all based on forecast-backed price trends. Avoid overstocking and missed opportunities.'
  },
  {
    title: 'Stronger sales & customer engagement',
    description: 'Offer dynamic, market-aligned pricing to your customers. Structure flexible or fixed-term contracts with confidence in price trajectories.'
  },
  {
    title: 'Financial & budgetary accuracy',
    description: 'Integrate forecasted prices into project costing and financial plans. Stay on budget, anticipate cost escalations, and support contract clauses with solid data.'
  },
  {
    title: 'Enhanced negotiation & risk management',
    description: 'Enter discussions with suppliers and buyers backed by market signals. Use forecast trends to hedge against volatility and secure better deal outcomes.'
  }
];

const ForecastingMatters = () => {
  return (
    <section className="forecasting-matters-section">
      <div className="forecasting-matters-container">
        <div className="section-header">
          <h2>Why forecasting matters</h2>
          <div className="header-line"></div>
        </div>

        <div className="matters-grid">
          {mattersData.map((item, index) => (
            <div key={index} className="matter-card">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ForecastingMatters;